import React from 'react';
import { css } from 'styled-components';

// Components
import Layout from 'src/components/common/theme/Layout';

//helpers
import { checkValue } from 'src/components/common/helper';

//types
import { HeroColorBarProps } from '../../typings';

const HeroColorBar: React.FC<HeroColorBarProps> = (props) => {
  const { barColorLeft, barColorRight, turnOffRectangleBarsForMobile } = props;
  const isColorBarOnMobile = (checkValue(turnOffRectangleBarsForMobile) && turnOffRectangleBarsForMobile === 'True') ? true : false; 

  const moduleCss = () => {
    return `
    ${
      checkValue(barColorLeft) ? `&.hero-color-bar-component .color-bar-left { background-color: ${barColorLeft} !important }` : ''
    }
    ${
      checkValue(barColorRight)
        ? `&.hero-color-bar-component .color-bar-right { background-color: ${barColorRight} !important }`
        : ''
    }
    `;
  };
  return (
    <Layout
      css={css`
        ${moduleCss()}
      `}
      className={`hero-color-bar-component ${isColorBarOnMobile ? 'hidecolorbars' : ''}`}
    >
      {checkValue(barColorLeft) && <div className="hero-color-bar color-bar-left"></div>}
      {checkValue(barColorRight) && <div className="hero-color-bar color-bar-right"></div>}
    </Layout>
  );
};

export default HeroColorBar;
